import { create } from "zustand"
import { persist } from "zustand/middleware"

import { appendCapped } from "./escalation-review-state"

interface ImprovedRepliesState {
	// Agent replies someone fixed from the Improve reply panel, oldest first.
	improvedMessageIds: string[]
	markImproved: (messageId: string) => void
}

export const useImprovedRepliesState = create<ImprovedRepliesState>()(
	persist(
		(set, get) => ({
			improvedMessageIds: [],
			markImproved: (messageId) =>
				set({
					improvedMessageIds: appendCapped(get().improvedMessageIds, messageId),
				}),
		}),
		{ name: "improved-replies-state" },
	),
)
